import styled from 'styled-components';
import { zIndex } from 'tokens';

export const Base = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	gap: 6px;
	pointer-events: auto;
`;

export const IconButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	border-radius: 4px;
	background: transparent;
	border: none;
	padding: 0;
	color: inherit;
	font: inherit;
	appearance: none;

	&:hover {
		background: ${({ theme }) => theme.gray[200]};
	}
	&:active {
		background: ${({ theme }) => theme.gray[400]};
	}
`;

export const Popover = styled.div<{ $isOpen: boolean }>`
	position: absolute;
	bottom: calc(100% + 8px);
	right: 0;
	width: 260px;
	background: ${({ theme }) => theme.gray[0]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 8px;
	padding: 12px;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);
	z-index: ${zIndex.island};
	opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
	pointer-events: ${({ $isOpen }) => ($isOpen ? 'all' : 'none')};
	transform: ${({ $isOpen }) => ($isOpen ? 'translateY(0) scale(1)' : 'translateY(-4px) scale(0.95)')};
	transform-origin: bottom right;
	transition: opacity 0.2s ease-out, transform 0.2s ease-out;
	text-align: left;
`;

export const Label = styled.div`
	font-size: 11px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[400]};
	text-transform: uppercase;
	letter-spacing: 0.05em;
	margin-bottom: 6px;
`;

export const Header = styled.div<{ $clickable?: boolean }>`
	display: flex;
	align-items: center;
	gap: 8px;
	margin-top: 6px;
	padding: 12px 10px;
	border-radius: 8px;
	transition: background-color 0.15s ease;

	&:hover {
		background: ${({ $clickable, theme }) => ($clickable ? theme.gray[100] : 'transparent')};
	}
`;

export const NameGroup = styled.div`
	display: flex;
	align-items: baseline;
	gap: 6px;
	flex: 1;
	min-width: 0;
`;

export const Name = styled.div`
	font-size: 15px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[1000]};
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const VersionText = styled.span`
	font-size: 13px;
	font-weight: 500;
	color: ${({ theme }) => theme.blue[500]};
	flex-shrink: 0;
`;

export const HeaderArrow = styled.div`
	flex-shrink: 0;
	display: flex;
	align-items: center;
`;
